import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=31341cfe&scoped=true&"
import script from "./Notify.vue?vue&type=script&lang=js&"
export * from "./Notify.vue?vue&type=script&lang=js&"
import style0 from "./Notify.vue?vue&type=style&index=0&id=31341cfe&prod&lang=css&"
import style1 from "./Notify.vue?vue&type=style&index=1&id=31341cfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31341cfe",
  null
  
)

export default component.exports